// Environment configuration
export const config = {
  // App information
  appName: import.meta.env.VITE_APP_NAME || "DPP Vision Portal",
  environment: import.meta.env.VITE_APP_ENV || "development",

  // API configuration
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:3000/api",

  // Debug and logging
  isDebug: import.meta.env.VITE_APP_DEBUG === "true",
  logLevel: import.meta.env.VITE_APP_LOG_LEVEL || "info",

  // Monitoring page URL
  monitoringPageUrl: import.meta.env.VITE_APP_MONITORING_PAGE,

  // Dashboard page URL
  dashboardPageUrl: import.meta.env.VITE_APP_DASHBOARD_PAGE,

  // Environment flags
  isLocalhost: import.meta.env.MODE === "localhost",
  isDevelopment: import.meta.env.MODE === "development",
  isProduction: import.meta.env.MODE === "prod",
  isTest: import.meta.env.MODE === "test",
} as const;

// Global constants (defined in vite.config.ts)
declare global {
  const __DEV__: boolean;
  const __PROD__: boolean;
  const __TEST__: boolean;
  const __LOCALHOST__: boolean;
}

export default config;
